// extracted by css-extract-rspack-plugin
export default {"warning":"TlAcEv"};